import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import $ from 'jquery';


const CashAccountAgreement = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // State variables
  const [errors, setErrors] = useState([]);
  const [err, setErr] = useState([]);
  const [docFile, setDocFile] = useState(null);
  const [token, setToken] = useState('');
  const [approval, setApproval] = useState('');
  const [confirm, setConfirm] = useState(0);
  const [linkCode, setLinkCode] = useState('');
  const [docName, setDocName] = useState('Accountant document');
  const [docFileError, setDocFileError] = useState('');
  const [form, setForm] = useState({});
  const [countries, setCountries] = useState([]);
  const [errorFlag, setErrorFlag] = useState(0);
  const [noOfCashAc, setNoOfCashAc] = useState(1);
  const [confirmError, setConfirmError] = useState('');
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isCorporate, setIsCorporate] = useState(0);
  const [corpDirectors, setCorpDirectors] = useState([]);
  const [corpToken, setCorpToken] = useState('');
  const [isDirector, setIsDirector] = useState(0);
  const [dirError, setDirError] = useState(0);
  const [uToken, setUToken] = useState('');
  const [accountCurrency, setAccountCurrency] = useState([]);
  const [nameOfPersons1, setNameOfPersons1] = useState([]);
  const [emailOfPersons1, setEmailOfPersons1] = useState([]);
  const [phoneOfPersons1, setPhoneOfPersons1] = useState([]);
  const [authorityOfPersons1, setAuthorityOfPersons1] = useState([]);
  const [nameOfPersons2, setNameOfPersons2] = useState([]);
  const [emailOfPersons2, setEmailOfPersons2] = useState([]);
  const [phoneOfPersons2, setPhoneOfPersons2] = useState([]);
  const [authorityOfPersons2, setAuthorityOfPersons2] = useState([]);
  const [approvalDocList, setApprovalDocList] = useState([]);
  const [directorInput, setDirectorInput] = useState([]);
  const [currentDate, setCurrentDate] = useState(dayjs(new Date()).format("DD/MM/YYYY"));
  const [urlParas, setUrlParas] = useState({});
  const [localStorageData, setLocalStorageData] = useState({});
  
  const errorBlockRef = useRef();
  const subBtnRef = useRef();

  const STORAGE_KEY = "caprock-local";
  
  // Base API URL - replace with your actual API base URL
  const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.caprock.com.au/';

  useEffect(() => {
    initializeComponent();
  }, []);

  const initializeComponent = () => {
    const js = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    setLocalStorageData(js);

    const tokenParam = searchParams.get('token');
    const approvalParam = searchParams.get('approval');
    const ltokenParam = searchParams.get('ltoken');

    setToken(tokenParam || '');
    setApproval(approvalParam || '');
    setLinkCode(ltokenParam || '');

    setAccountCurrency(['']);
    setCorpToken(tokenParam || '');
    setUToken(tokenParam || '');

    checkTokenUserType();
    tokenAlert();
    
    if (approval && approval !== '') {
      isApprovalValid(approval);
    } else {
      isApprovalValid(0);
    }

    setForm(prev => ({
      ...prev,
      curdate: dayjs(new Date()).format("YYYY-MM-DD")
    }));

    document.title = `${docName} || Caprock Merchant Platform`;

    getCountries();
  };

  const checkTokenUserType = async () => {
    const uType = await getUserType();
    let tokenType = null;
    let formData = new FormData();
            formData.append('user_token', localStorageData['access-token']);

    if (uToken && uToken !== 'undefined' && uToken !== null) {
      formData.append('token', uToken);
      const url = BASE_URL + 'get-user-token-info';

      try {
        const response = await fetch(url, {
          method: 'POST',
          body: formData,
          headers: {
            'Access-Control-Allow-Origin': '*'
          }
        });

        const data = await response.json();

        if (data.success === 200) {
          tokenType = data.userType;
          if (uType !== tokenType) {
            if (tokenType !== 'my') {
              const cNo = tokenType.replace('business_', '');
              await switchProfile('business', cNo);
            } else {
              await switchProfile('my', 0);
            }
          }
        } else {
          toast.info(data.message);
        }
      } catch (error) {
        toast.error('Failed to upload');
        return false;
      }
    } else {
      toast.info('Please select file first');
    }
  };

  const getUserType = () => {
    return localStorage.getItem('active_profile');
  };

  const switchProfile = async (pType, companyNo = 0) => {
    if (pType === 'business') {
      try {
        const response = await switchBusinessAccount(token, 2, companyNo);
        if (response.data && response.data.success === 200) {
          localStorage.setItem('active_profile', 'business_' + companyNo);
          window.location.reload();
        }
      } catch (e) {
        console.log(e);
      }
    } else if (pType === 'my') {
      try {
        const response = await switchBusinessAccount(token, 1, companyNo);
        if (response.data && response.data.success === 200) {
          localStorage.setItem('active_profile', 'my');
          window.location.reload();
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const switchBusinessAccount = async (token, type, companyNo) => {
    const formData = new FormData();
    formData.append('token', token);
    formData.append('type', type);
    formData.append('company_no', companyNo);
    
    const response = await fetch(BASE_URL + 'switch-business-account', {
      method: 'POST',
      body: formData,
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    });
    
    return { data: await response.json() };
  };

  const updateACurrency = () => {
    const newAccountCurrency = [];
    for (let i = 0; i < noOfCashAc; i++) {
      newAccountCurrency[i] = accountCurrency[i];
      if (typeof accountCurrency[i] === 'undefined' || accountCurrency[i] === null) {
        newAccountCurrency[i] = '';
      }
    }
    setAccountCurrency(newAccountCurrency);
  };

  const getCountries = () => {
    fetch(BASE_URL + 'get-countries-list')
      .then(response => response.json())
      .then(data => {
        if (data && data.success === 200) {
          setCountries(data.countries);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const fetchFile = (event) => {
    const file = event.target.files;
    if (event.target.name === 'doc_file') {
      setDocFile(file);
      setForm(prev => ({
        ...prev,
        doc_file_name: file.name
      }));
    }
  };

  const tokenAlert = () => {
    if (!token || token === '' || token === 'undefined') {
      alert('This URL is invalid please contact caprock support team');
    //   window.location.href = 'https://caprock.com.au';
    }
  };

  const setDirectors = (userId) => {
    setIsCorporate(1);
    getDirectorsToken(corpToken)
      .then(response => {
        if (response.data && response.data.success !== 200) {
          toast.warning('Invalid Token!');
          setTimeout(() => {
            window.location.href = "https://caprock.com.au";
          }, 2500);
        } else {
          setCorpDirectors(response.data.directors);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const getDirectorsToken = (corpToken) => {
    const formData = new FormData();
    formData.append('corp_token', corpToken);
    
    return fetch(BASE_URL + 'get-directors-token', {
      method: 'POST',
      body: formData,
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    }).then(response => response.json()).then(data => ({ data }));
  };

  const isApprovalValid = (approvalId) => {
    const formData = new FormData();
    formData.append('approval_id', approvalId);
    formData.append('token', token);

    fetch(BASE_URL + 'is-approval-valid', {
      method: 'POST',
      body: formData,
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data && data.success !== 200) {
          toast.warning('Link expired!');
          setTimeout(() => {
            window.location.href = "https://caprock.com.au";
          }, 2500);
        } else {
          if (data.data.user_type === 2 || data.data.user_type === '2') {
            setDirectors(data.data.user_id);
          }

          if (data.data.approval_doc_list.length > 0) {
            setApprovalDocList(data.data.approval_doc_list);
          }

          if (data.data.approval_directors && data.data.approval_directors !== '') {
            if (data.master && data.master.approval_response) {
              const apRes = JSON.parse(data.master.approval_response);
              if (apRes) {
                setNoOfCashAc(apRes['no_of_cash_ac']);
                setAccountCurrency(apRes['cash_accounts']['account_currency']);
              }
            }

            setCorpToken(data.data.master_token);
            setDirectorInput(JSON.parse(data.data.approval_directors));
            setDirectors(data.data.director_master_id);
            setIsDirector(1);
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const submitForm = (e) => {
    $(subBtnRef.current).attr('disabled', 'disabled');
    $(subBtnRef.current).text('Processing ... ');

    const updatedForm = {
      ...form,
      cash_accounts: {
        is_corporate: isCorporate,
        account_currency: accountCurrency,
        name_of_persons_1: nameOfPersons1,
        email_of_persons_1: emailOfPersons1,
        phone_of_persons_1: phoneOfPersons1,
        authority_of_persons_1: authorityOfPersons1,
        name_of_persons_2: nameOfPersons2,
        email_of_persons_2: emailOfPersons2,
        phone_of_persons_2: phoneOfPersons2,
        authority_of_persons_2: authorityOfPersons2,
        director_input: directorInput
      },
      no_of_cash_ac: noOfCashAc
    };

    const js = JSON.parse(JSON.stringify(updatedForm));

    // Validation Check
    setErrors([]);
    setErrorFlag(0);
    setDirError(0);

    const required = [
      { 'key': 'e_name', 'name': 'Your Name' },
      { 'key': 'e_email', 'name': 'Email' },
      { 'key': 'e_phone_no', 'name': 'Phone No' },
      { 'key': 'e_dob', 'name': 'Date Of Birth' }
    ];

    const validEmails = [
      { 'key': 'e_email', 'name': 'E-Signature Email' }
    ];

    const validPhones = [
      { 'key': 'e_phone_no', 'name': 'E-Signature Phone' }
    ];

    if (noOfCashAc < 1) {
      setErrorFlag(1);
      toast.warning('Please enter valid number of cash accounts');
    } else {
      if (isCorporate === 0) {
        for (let i = 1; i <= noOfCashAc; i++) {
          required.push({ 'key': 'name_of_persons_1_' + i, 'name': 'Full name and official position' });
          required.push({ 'key': 'phone_of_persons_1_' + i, 'name': 'Phone Number' });
          required.push({ 'key': 'email_of_persons_1_' + i, 'name': 'Email Address' });
          required.push({ 'key': 'authority_of_persons_1_' + i, 'name': 'Authority' });
          required.push({ 'key': 'account_currency_' + i, 'name': 'Select Currency' });

          validPhones.push({ 'key': 'phone_of_persons_1_' + i, 'name': 'Phone Number' });
          validEmails.push({ 'key': 'email_of_persons_1_' + i, 'name': 'Email Address' });
        }
      }
    }

    for (let i = 0; i < validEmails.length; i++) {
      validEmail(validEmails[i]['key'], validEmails[i]);
    }

    for (let i = 0; i < required.length; i++) {
      requiredInput(required[i]['key'], required[i]);
    }

    let formData = new FormData();

    if (confirm === 0) {
      setConfirmError("Please agree to condition.");
      setErrorFlag(1);
    } else {
      setConfirmError("");
    }

    const cAcs = js['cash_accounts'];
    const currencies = cAcs['account_currency'];

    // Currency validation
    if (currencies.length === 0 || currencies.length < noOfCashAc) {
      setErrorFlag(1);
      setDirError(1);
      setDocFileError('Please select valid currency for All Cash Accounts.');
      toast.warning(docFileError);
    } else {
      for (let i = 0; i < currencies.length; i++) {
        if (!currencies[i] || currencies[i] === '') {
          setErrorFlag(1);
          setDirError(1);
          setDocFileError('Please select valid currency account no - ' + String(i + 1));
          toast.warning(docFileError);
        }
      }
    }

    if (isCorporate === 1 && corpDirectors.length > 0) {
      const dList = cAcs['director_input'];

      for (let i = 0; i < noOfCashAc; i++) {
        let dirExist = 0;
        for (let ds = 0; ds < corpDirectors.length; ds++) {
          if (dList.includes(corpDirectors[ds]['director_id'] + '_' + i)) {
            dirExist = 1;
          }
        }
        if (dirExist === 0) {
          setDirError(1);
          setErrorFlag(1);
          setDocFileError('Please check at list one director for Cash Account No - ' + String(i + 1));
          toast.warning(docFileError);
        }

        if (!currencies[i] || currencies[i] === '') {
          setErrorFlag(1);
          setDirError(1);
          setDocFileError('Please select valid currency account no - ' + String(i + 1));
          toast.warning(docFileError);
        }
      }
    }

    if (errorFlag === 0) {
      for (const key in js) {
        if (key === 'cash_accounts') {
          formData.append(key, JSON.stringify(js[key]));
        } else {
          formData.append(key, js[key]);
        }
      }

      $(subBtnRef.current).attr('disabled', 'disabled');
      $(subBtnRef.current).text('Processing ... ');
      formData.append('token', token);
      formData.append('approval', approval);

      const url = BASE_URL + 'customer-approval-agreement';

      fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.success === 200) {
            toast.success(data.message);
            setTimeout(() => {
              navigate('/sign-in');
            }, 2500);

            $(subBtnRef.current).removeAttr('disabled');
            $(subBtnRef.current).text('Submit Now');
          } else {
            toast.warning(data.message);
            $(subBtnRef.current).removeAttr('disabled');
            $(subBtnRef.current).text('Submit Now');
          }
        })
        .catch(error => {
          $(subBtnRef.current).removeAttr('disabled');
          $(subBtnRef.current).text('Submit Now');
        });
    } else {
      if (dirError !== 1) {
        setDocFileError('Please fill E-Signature & other details required in form before submiting.');
      }
      toast.warning(docFileError);
      $(subBtnRef.current).removeAttr('disabled');
      $(subBtnRef.current).text('Submit Now');
      return false;
    }
  };

  const checkPhone = (event) => {
    const tagName = event.target.name;
    const ph = event.target.value;
    let valid = 1;
    let errorMsg = 'Please enter valid phone number';

    if (ph.length < 7 || ph.length > 12) {
      valid = 0;
      errorMsg = 'Phone number length is not valid';
    }
    if (isNaN(ph)) {
      valid = 0;
      errorMsg = 'Only number character is allowed';
    }
    if (ph === '') {
      valid = 0;
      errorMsg = 'Please enter phone number';
    }

    $('.' + tagName + 'err').html('');
    if (valid === 0) {
      $("#" + tagName).before('<span class="' + tagName + 'err errorMsg danger ml-2 float-right">' + errorMsg + '</span>');
    }
  };

  const validEmail = (eId, obj) => {
    const tagName = $("#" + eId).attr("name");
    const eVal = $("#" + eId).val();
    let valid = 1;
    let errorMsg = 'Please enter valid email address';
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (obj && obj !== null) {
      errorMsg = 'Please enter a valid email address for field - ' + obj.name;
    }
    if (!re.test(String(eVal).toLowerCase())) {
      valid = 0;
    }
    $('.' + tagName + 'err').html('');
    if (valid === 0) {
      setErrorFlag(1);
      $("#" + eId).before('<span class="' + tagName + 'err errorMsg danger ml-2 float-right">' + errorMsg + '</span>');
    }
  };

  const requiredInput = (rId, obj) => {
    const tagName = $("#" + rId).attr("name");
    const rVal = $("#" + rId).val();
    let valid = 1;
    let em = 'Field required';

    if (rVal === undefined || rVal === '' || rVal === null) {
      em = tagName + ' is required';
      valid = 0;
    }
    if (obj && obj !== null) {
      em = obj.name + ' is required';
    }

    if (valid === 0) {
      setErrorFlag(1);
      $('.' + tagName + 'err').html('');
      $("#" + rId).before('<span class="' + tagName + 'err errorMsg danger ml-2 float-right">' + em + '</span>');
    }
  };

  const removeTagErr = (event) => {
    const tagName = event.target.name;
    $('.' + tagName + 'err').html('');
  };

  const openModal = (id) => {
    $('#' + id).addClass('d-block');
    $('#' + id).addClass('show');
    $('#' + id).css('overflow-y', 'scroll');
  };

  const closeModal = (id) => {
    $('#' + id).removeClass('d-block');
    $('#' + id).addClass('d-none');
    $('#' + id).removeClass('show');
  };

  const handleCurrencyChange = (index, value) => {
    const newAccountCurrency = [...accountCurrency];
    newAccountCurrency[index] = value;
    setAccountCurrency(newAccountCurrency);
  };

  const handlePersonChange = (type, index, field, value) => {
    if (type === '1') {
      const newArray = [...nameOfPersons1];
      newArray[index] = value;
      setNameOfPersons1(newArray);
    } else if (type === '2') {
      const newArray = [...nameOfPersons2];
      newArray[index] = value;
      setNameOfPersons2(newArray);
    }
  };

  const handleDirectorInput = (directorId, accountIndex) => {
    const newDirectorInput = [...directorInput];
    const value = directorId + '_' + accountIndex;
    
    if (newDirectorInput.includes(value)) {
      const index = newDirectorInput.indexOf(value);
      newDirectorInput.splice(index, 1);
    } else {
      newDirectorInput.push(value);
    }
    
    setDirectorInput(newDirectorInput);
  };

  return (
    <>
      <section className="closefriend-hero background-white">
        <div className="container mt-3">
          <form method="POST" action="/" className="my-1">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1">
                <div className="row">
                  <div className="col-md-12 col-12 text-center">
                    <p style={{ fontSize: '2rem', fontWeight: 700, letterSpacing: '0.1rem', lineHeight: 'normal' }}>
                      Cash Account Agreement
                    </p>
                  </div>
                </div>

                <div className="login-card bg-white p-4" style={{ borderRadius: '6px' }}>
                  <div className="login-body">
                    <div className="row">
                      <div className="form-group mt-1 mb-0 col-md-6">
                        <h5>How many Cash Account required ?</h5>
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          disabled={isDirector === 1}
                          onChange={(e) => {
                            setNoOfCashAc(parseInt(e.target.value));
                            updateACurrency();
                          }}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          type="number"
                          className="form-control font-size-15-18 text-center selected-field"
                          value={noOfCashAc}
                          name="no_of_cash_ac"
                          id="no_of_cash_ac"
                          required
                        />
                      </div>
                    </div>

                    {Array.from({ length: noOfCashAc }, (_, index) => (
                      <div key={index}>
                        <hr />
                        <div className="row">
                          <div className="col-md-6">
                            <h4 className="text-left">Cash Account : {index + 1}</h4>
                          </div>
                          <div className="form-group col-md-6">
                            <select
                              disabled={isDirector === 1}
                              onChange={(e) => handleCurrencyChange(index, e.target.value)}
                              value={accountCurrency[index] || ''}
                              className="form-control"
                              id={`account_currency_${index + 1}`}
                              name={`account_currency_${index + 1}`}
                            >
                              <option value="">Select Currency</option>
                              {countries.filter(info => info.currency !== '').map((c, i) => (
                                <option key={i} value={c.currency}>
                                  {c.currency} - {c.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {isCorporate === 0 && (
                          <div className="row">
                            <div className="col-12">
                              <h5>Authorised persons:</h5>
                              <p style={{ color: '#7f888f' }}>
                                Persons Authorised to give Instructions. Changes to this need to be received in writing before they take effect:
                              </p>
                            </div>
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('1', index, 'name', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Full Name and Official Position"
                                className="form-control selected-field"
                                value={nameOfPersons1[index] || ''}
                                id={`name_of_persons_1_${index + 1}`}
                                name={`name_of_persons_1_${index + 1}`}
                                required
                              />
                            </div>
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('1', index, 'authority', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Authority (Signature Required)"
                                className="form-control selected-field"
                                value={authorityOfPersons1[index] || ''}
                                name={`authority_of_persons_1_${index + 1}`}
                                id={`authority_of_persons_1_${index + 1}`}
                                required
                              />
                            </div>
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('1', index, 'phone', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Phone Number"
                                className="form-control selected-field"
                                value={phoneOfPersons1[index] || ''}
                                name={`phone_of_persons_1_${index + 1}`}
                                id={`phone_of_persons_1_${index + 1}`}
                                required
                              />
                            </div>
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('1', index, 'email', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Email Address"
                                className="form-control selected-field"
                                value={emailOfPersons1[index] || ''}
                                name={`email_of_persons_1_${index + 1}`}
                                id={`email_of_persons_1_${index + 1}`}
                                required
                              />
                            </div>
                          </div>
                        )}

                        {(isCorporate === 0 || corpDirectors.length === 0) && (
                          <div className="row">
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('2', index, 'name', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Full Name and Official Position"
                                className="form-control selected-field"
                                value={nameOfPersons2[index] || ''}
                                name={`name_of_persons_2_${index + 1}`}
                                id={`name_of_persons_2_${index + 1}`}
                              />
                            </div>
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('2', index, 'authority', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Authority: Signature Required?"
                                className="form-control selected-field"
                                value={authorityOfPersons2[index] || ''}
                                name={`authority_of_persons_2_${index + 1}`}
                                id={`authority_of_persons_2_${index + 1}`}
                              />
                            </div>
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('2', index, 'phone', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Phone Number"
                                className="form-control selected-field"
                                value={phoneOfPersons2[index] || ''}
                                name={`phone_of_persons_2_${index + 1}`}
                                id={`phone_of_persons_2_${index + 1}`}
                              />
                            </div>
                            <div className="form-group col-md-3">
                              <input
                                onChange={(e) => handlePersonChange('2', index, 'email', e.target.value)}
                                onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                                autoComplete="off"
                                type="text"
                                placeholder="Email Address"
                                className="form-control selected-field"
                                value={emailOfPersons2[index] || ''}
                                name={`email_of_persons_2_${index + 1}`}
                                id={`email_of_persons_2_${index + 1}`}
                              />
                            </div>
                          </div>
                        )}

                        {isCorporate === 1 && corpDirectors.length > 0 && (
                          <div className="row">
                            <div className="col-12">
                              <h5>Authorised persons:</h5>
                              <p style={{ color: '#7f888f' }}>
                                Persons Authorised to give Instructions. Changes to this need to be received in writing before they take effect:
                              </p>
                            </div>
                            {corpDirectors.map((director) => (
                              <div className="form-group col-md-12" key={director.director_id}>
                                <input
                                  disabled={isDirector === 1}
                                  id={`${director.director_id}_${index}`}
                                  checked={directorInput.includes(`${director.director_id}_${index}`)}
                                  onChange={() => handleDirectorInput(director.director_id, index)}
                                  className="normalCheckbox"
                                  type="checkbox"
                                  name="director_input"
                                />
                                <label htmlFor={`${director.director_id}_${index}`} className="normalLabel">
                                  {director.director_name} ({director.director_email})
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="login-card bg-white p-4 mt-3" style={{ borderRadius: '6px' }}>
                  <div className="login-body">
                    <div className="form-group mt-1 mb-0">
                      <h5>
                        E-Signature
                        <label className="label float-right">Date : {currentDate}</label>
                      </h5>
                      <hr />
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => setForm(prev => ({ ...prev, e_name: e.target.value }))}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          type="text"
                          placeholder="Your Name"
                          className="form-control selected-field"
                          value={form.e_name || ''}
                          name="e_name"
                          id="e_name"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => setForm(prev => ({ ...prev, e_email: e.target.value }))}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          type="text"
                          placeholder="Your Email Address"
                          className="form-control selected-field"
                          value={form.e_email || ''}
                          name="e_email"
                          id="e_email"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => {
                            setForm(prev => ({ ...prev, e_phone_no: e.target.value }));
                            checkPhone(e);
                          }}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          type="text"
                          placeholder="Your Phone Number"
                          className="form-control selected-field"
                          value={form.e_phone_no || ''}
                          name="e_phone_no"
                          id="e_phone_no"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => setForm(prev => ({ ...prev, e_dob: e.target.value }))}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          value={form.e_dob || ''}
                          type="date"
                          placeholder="Your Date of Birth"
                          className="form-control selected-field"
                          name="e_dob"
                          id="e_dob"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group mt-1 mb-0">
                      <input
                        id="icheck"
                        type="checkbox"
                        className="form-control"
                        name="icheck"
                        required
                        checked={confirm === 1}
                        onChange={(e) => setConfirm(e.target.checked ? 1 : 0)}
                      />
                      <span
                        className="p-cursor"
                        onClick={() => {
                          setConfirm(0);
                          setConfirmError('');
                        }}
                        style={{ display: confirm === 1 ? 'inline' : 'none' }}
                      >
                        <svg style={{ height: '15px', width: '15px', margin: '5px' }} width="100mm" height="100mm" version="1.1" viewBox="0 0 100 100">
                          <defs>
                            <clipPath id="a">
                              <path d="m139.21 139.21h473.58v473.58h-473.58z" inkscapeConnectorCurvature="0" />
                            </clipPath>
                          </defs>
                          <g transform="translate(0,-197)" inkscapeGroupmode="layer" inkscapeLabel="Layer 1">
                            <g transform="matrix(1.6371 0 0 1.6371 16.358 -155.86)">
                              <path d="m-8.417 217.52h57.655v57.655h-57.655z" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="1.6707" inkscapeConnectorCurvature="0" />
                              <g transform="matrix(.35278 0 0 .35278 -152.74 113.7)" clipPath="url(#a)">
                                <path transform="matrix(4.7358,0,0,4.7358,139.21,139.21)" d="m64.04 52.74 6.31 6.9806 13.98-20.311" fill="none" stroke="#000" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="5" inkscapeConnectorCurvature="0" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span
                        className="p-cursor"
                        onClick={() => {
                          setConfirm(1);
                          setConfirmError('');
                        }}
                        style={{ display: confirm === 0 ? 'inline' : 'none' }}
                      >
                        <svg style={{ height: '15px', width: '15px', margin: '5px' }} width="100mm" height="100mm" viewBox="0 0 100 100">
                          <defs>
                            <clipPath id="a">
                              <path d="m139.21 139.21h473.58v473.58h-473.58z" inkscapeConnectorCurvature="0" />
                            </clipPath>
                          </defs>
                          <g transform="translate(0,-197)" inkscapeGroupmode="layer" inkscapeLabel="Layer 1">
                            <path d="m2.5789 200.25h94.389v94.389h-94.389z" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="2.7351" inkscapeConnectorCurvature="0" />
                          </g>
                        </svg>
                      </span>
                      <label className="label">
                        I confirm that I have received, agreed and knowledge the following documents.
                      </label>
                      <ol style={{ fontSize: '13px' }}>
                        {approvalDocList.map((doc, index) => (
                          <li key={index}>{doc}</li>
                        ))}
                      </ol>
                      <small className="errorMsg danger ml-2">{confirmError}</small>
                    </div>
                  </div>
                  <div className="row justify-content-center mx-md-0 mx-1 mb-1 mt-0">
                    <div className="col-md-12 col-12 px-1">
                      <button
                        id="subBtn"
                        type="button"
                        onClick={submitForm}
                        ref={subBtnRef}
                        className="btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                      >
                        Submit Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Please fix this</h5>
              <button type="button" onClick={() => closeModal('exampleModal')} className="btn btn-secondary" data-mdb-dismiss="modal">
                Close
              </button>
            </div>
            <div className="modal-body">
              <div ref={errorBlockRef} id="errorBlock">
                {errors.length > 0 && errors.map((error, key) => (
                  <div key={key} className="alert alert-danger">
                    {error}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CashAccountAgreement;
